import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll<HTMLElement>('[data-countup]');

	elements.forEach((el) => {
		const rawValue = el.dataset.countup || '0';
		const match = rawValue.match(/^([\d.,]+)(.*)$/);
		const endValue = parseFloat(match?.[1] || '0');
		const suffix = match?.[2] || '';

		const duration = parseFloat(el.dataset.duration || '2');
		const startValue = parseFloat(el.dataset.countupStart || '0');
		const obj = { val: startValue };

		ScrollTrigger.create({
			trigger: el,
			start: 'top 80%',
			onEnter: () => {
				gsap.to(obj, {
					val: endValue,
					duration,
					ease: 'power1.out',
					onUpdate: () => {
						el.textContent = Math.floor(obj.val).toString() + suffix;
					},
				});
			},
			once: true,
		});
	});
});
